import React from 'react';
import { deepmerge } from '@mui/utils';
import { grey } from '@mui/material/colors';
import CircularProgress from '@mui/material/CircularProgress';
import { ButtonProps } from '@mui/material/Button';
import Button from '@/components/Button/Button';
import { theme } from '@/core/theme/theme';

type SubmitButtonProps = {
  isLoading?: boolean;
} & ButtonProps;

function SubmitButton({ isLoading = false, children, sx, ...props }: SubmitButtonProps) {
  const defaultStyles = {
    color: theme.palette.primary.main,
    backgroundColor: grey['50'],
    '&:hover': {
      backgroundColor: grey['100'],
    },
    '&:disabled': {
      backgroundColor: grey[50] + 'AF',
      color: grey['900'],
    },
  };
  return (
    <Button size="medium" variant="contained" sx={deepmerge(defaultStyles, sx)} {...props}>
      {isLoading ? <CircularProgress size={20} color="inherit" sx={{ mr: 2 }} /> : null}
      {children}
    </Button>
  );
}

export default SubmitButton;
